import wysiwygFromDom from 'Modules/wysiwyg/services/wysiwygFromDom';

window._define('bridge/modules/wysiwyg', () => wysiwygFromDom);
